import React from 'react';
import './VideoCard.css';

const VideoCard = ({ video, onClick }) => {
  return (
    <button
      className="vcard"
      onClick={() => onClick(video)}
      aria-label={`Assistir vídeo de ${video.name}`}
    >
      <div
        className="vcard-thumb"
        style={{ backgroundImage: `url(/${video.thumbnail})` }}
      >
        <div className="vcard-play" />
      </div>
      <div className="vcard-info">
        <div className="vcard-nome">{video.name}</div>
        <div className="vcard-setor">{video.sector}</div>
      </div>
    </button>
  );
};

export default VideoCard;
